const OPEN_ENDED_NEXT_WEIGHT = 99999999.99;

const toRoundedLabelNumber = (value) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return "";
  }

  return String(Math.round(numericValue));
};

export const formatBandHeader = ({ weight, nextWeight }) => {
  const start = toRoundedLabelNumber(weight);
  const endValue = Number(nextWeight);

  if (endValue >= OPEN_ENDED_NEXT_WEIGHT) {
    return `${start}+ кг`;
  }

  return `${start}-${Math.ceil(endValue)} кг`;
};

export const buildBandColumnKey = ({ weight, nextWeight }) =>
  `${Number(weight).toFixed(2)}_${Number(nextWeight).toFixed(2)}`;

export const ALL_POINTS_GROUP = "Все точки";

// У точки кросс-докинга нет перевозчика: тариф привязан к самой точке, все
// точки — одна группа.
export const buildCarrierGroups = (registryRows = []) => {
  if (!registryRows.length) {
    return [];
  }

  const rows = registryRows.map((row) => ({
    ...row,
    id: row?.id ?? row?.crossDockingPointId ?? row?.kato,
  }));

  return [{
    key: ALL_POINTS_GROUP,
    label: ALL_POINTS_GROUP,
    rows,
    crossDockingPointIds: rows.map((row) => row.id),
  }];
};

export const joinRegistryWithTariffs = ({ registryRows = [], tariffRows = [] }) => {
  const tariffRowsByPointId = new Map(
    tariffRows.map((row) => [row.crossDockingPointId, row])
  );

  return registryRows.map((registryRow) => {
    const rowId = registryRow?.id ?? registryRow?.crossDockingPointId ?? registryRow?.kato;
    const matchedTariffRow = tariffRowsByPointId.get(rowId);

    return {
      crossDockingPointId: rowId,
      name: registryRow?.name || "",
      locality: registryRow?.locality || "\u2014",
      kato: matchedTariffRow?.kato || registryRow?.kato || "\u2014",
      address: registryRow?.address || "",
      isActive: Boolean(registryRow?.isActive),
      cells: matchedTariffRow?.cells || {},
    };
  });
};

export const buildDirtyPatchPayload = (dirtyRows = []) => ({
  rows: dirtyRows.map((row) => ({
    rowKey: {
      crossDockingPointId: row.crossDockingPointId,
      kato: row.kato,
    },
    changes: (row.changes || []).map((change) => ({
      id: change.id,
      price: Number(change.price),
      expectedUpdatedAt: change.updatedAt,
    })),
  })),
});
